"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 3c4.971 0 9 4.029 9 9s-4.029 9-9 9a9 9 0 0 1-9-9 9 9 0 0 1 9-9",
    opacity: ".15"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m14.231 9.068-2.327 2.327-2.327-2.327a.38.38 0 0 0-.537.537l2.327 2.327-2.327 2.327a.38.38 0 0 0 .537.537l2.327-2.327 2.327 2.327a.38.38 0 0 0 .537-.537l-2.327-2.327 2.327-2.327a.38.38 0 0 0-.537-.537"
  })]
}), 'ClearCircleTwoTone');
